import React, {Component} from "react";
import Header from "./components/header/Header";
import HeaderBackground from "./components/header/HeaderBackground";
import Footer from "./components/footer/FooterTop";
import {BrowserRouter as Router} from "react-router-dom";
import * as contentful from "contentful";
import Menu from "./components/content/menu/Menu";
import Title from "./components/content/main/Title";
import Content from "./components/content/main/Content";

class App extends Component {

    state = {
        pages: []
    };

    client = contentful.createClient({
        space: process.env.REACT_APP_CONTENTFUL_SPACE,
        accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
    });

    componentDidMount() {
        this.fetchPages().then(this.setPages);
    }

    fetchPages = () => this.client.getEntries();

    setPages = response => {
        console.log(response.items);
        this.setState({
            pages: response.items
        })
    };

    render() {
        return (
            <Router>
                <div>
                    <Header pages={this.state.pages}/>
                    <HeaderBackground
                        url="https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Chess-king.JPG/800px-Chess-king.JPG"/>
                    <div id="core" className="layout-content">
                        <div className="c-container">
                            <div className="row">
                                <div className="middle-column col-md-9 col-md-push-3">
                                    <Title pages={this.state.pages}/>
                                    <Content pages={this.state.pages}/>
                                    <hr className="c-separator m-margin-top-small m-margin-bottom-small m-transparent hidden-lg hidden-md"/>
                                </div>
                                <div className="left-column col-md-3 col-md-pull-9">
                                    <nav className="side-menu m-left-side m-show-submenu">
                                        <Menu pages={this.state.pages}/>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </Router>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js